<mbs-wizard
  class="mbs-wizard_flex-content"
  [buttonLoadingMode]="true"
  [canClosed]="!loadingPlan() && wizardFinish()"
  [loading]="loadingPlan()"
  [saveButton]="{ text: ('shared:buttons.proceed' | i18next) }"
  [scrollableStepContent]="true"
  [stepsOrientation]="'vertical'"
  [title]="wizardTitle"
  [(ngModel)]="stepsManager.currentStep"
  (save)="handleSave()">
  <mbs-wizard-step
    [title]="'wizards:generic.fromTo' | i18next"
    [valid]="fromToStep.valid()"
    ><mbs-generic-restore-from-to-step
      #fromToStep
      [presetComputer]="data?.computer"
      (fromToStepData)="fromToStepDataChangeHandler($event)"></mbs-generic-restore-from-to-step
  ></mbs-wizard-step>

  <mbs-wizard-step
    [title]="'wizards:generic.whatToRestore' | i18next"
    [valid]="whatToStep.valid()"
    ><mbs-generic-what-to-restore-step
      #whatToStep
      [fromToStepData]="FormModel?.fromToStepData"
      (whatToStepData)="whatToStepDataChangeHandler($event)"></mbs-generic-what-to-restore-step
  ></mbs-wizard-step>
</mbs-wizard>
